import React from 'react';
import axios from 'axios';
import {toast} from "react-toastify";

function Hearings({ hearings, onHearingDeleted, onEditClick }) {

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");

    if (window.confirm("Are you sure you want to delete this hearing?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/hearings/${id}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        toast.success("Hearing deleted successfully.");

        onHearingDeleted();
      } catch (error) {
        console.error("Error deleting hearing:", error);
          toast.error("Failed to delete hearing. Please try again later.");
      }
    }
  };

  const handleEdit = (id) => {
    onEditClick(id); // Open the Edit form popup
  };

  if (!hearings.length) {
    return (
      <div className="text-center">
        <p className="text-white">No hearings scheduled.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
   
      
      {hearings.map((hearing) => (
        <div
          key={hearing._id}
          className="bg-white rounded-xl shadow-md p-4 border border-gray-200 flex flex-col md:flex-row items-start gap-4"
        >
          <div className="flex-1">
            <h2 className="text-xl font-semibold mb-1">{hearing.caseTitle}</h2>
            <p className="text-gray-600">
              <span className="font-medium">Date:</span> {new Date(hearing.date).toLocaleDateString()}
            </p>
            <p className="text-gray-600">
              <span className="font-medium">Reminder:</span> {hearing.reminder ? 'Yes' : 'No'}
            </p>
            <p className="text-gray-600">
              <span className="font-medium">Notes:</span> {hearing.notes || '—'}
            </p>
          </div>

          <div className="flex flex-col gap-2 md:ml-auto">
            <button
              onClick={() => handleEdit(hearing._id)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded text-sm"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(hearing._id)}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Hearings;
